import React from 'react'
import Title from "../title/Title";
import ResumeCard from "./ResumeCard";
import { motion } from "framer-motion";
const Experience = ({ trainerExperienceData, jobExperienceData }) => {
  return (
    <motion.div
      initial={{ y: "100%", opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="w-full grid lg:grid-cols-2 gap-16"
    >
      {/* Job Experience */}
      <div>
        <Title
          title="2018 - present"
          desc="Job Experience"
          fontSize="text-2xl md:text-4xl"
        />
        <div className="w-full border-l-[6px] border-l-black border-opacity-30 flex flex-col space-y-10">
          {jobExperienceData.map((item) => (
            <ResumeCard item={item} key={item.id} />
          ))}
        </div>
      </div>
      {/* Experience */}
      <div>
        <Title
          title="2018 - 2019"
          desc="Trainer Experience"
          fontSize="text-2xl md:text-4xl"
        />
        <div className="w-full border-l-[6px] border-l-black border-opacity-30 flex flex-col space-y-10">
          {trainerExperienceData.map((item) => (
            <ResumeCard item={item} key={item.id} />
          ))}
        </div>
      </div>
    </motion.div>
  )
}

export default Experience